'use client';
import { useCallback } from 'react';
import { type UserDetails, useUserStore } from '../../../../../../auth/UserStoreProvider';
import { useAppDependencyGraphProvider } from '../../../../../context/DependencyGraphProvider';
import { ComputeContextKeys } from '../../../../../hooks/computeContext/const';
import {
  type UserContextInStore,
  useGlobalAppStateStore,
} from '../../../../../stores/app/GlobalAppStateStore';

export function useSetUserDetailsAndContext() {
  const userStore = useUserStore();
  const { setUserContext } = useGlobalAppStateStore().hooks.useActions();
  const { setCurrentUserDetails } = userStore.hooks.useActions();

  const {
    actions: { notifyDependencyChange },
  } = useAppDependencyGraphProvider();

  const setUserDetailsAndContext = useCallback(
    ({
      userContext,
      userDetails,
    }: {
      userContext?: UserContextInStore;
      userDetails?: UserDetails;
    }) => {
      if (userDetails) setCurrentUserDetails(userDetails);
      if (userContext) setUserContext(userContext);
      notifyDependencyChange({ id: ComputeContextKeys.USER_CONTEXT });
    },
    [setCurrentUserDetails, setUserContext, notifyDependencyChange],
  );

  return {
    setUserDetailsAndContext,
  };
}
